module.exports = __webpack_public_path__ + "static/media/borhene.c79016b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/borhene.png
// module id = 2268
// module chunks = 0